import get from 'lodash.get';
import status from 'src/js/modules/status';
import statusNames from '../constants/status-names';

const getSubscriptionReactivationStatus = (rootState) =>
  get(status.selectors.getStatus(rootState), statusNames.REACTIVATE_SUBSCRIPTION);

export default getSubscriptionReactivationStatus;
